(function(){
    angular.module('is-in-list-or-segment.dir', ['journey.veil'])
        .directive('listSegment', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService','$timeout', 'CANVAS_OPTS', listSegment]);

    function listSegment($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout, CANVAS_OPTS){
        return {
            scope: {},
            controller: ['$scope', function($scope){
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function(){
                    //If form data is missing
                    if($scope.dataFilledCorrectly() === false){
                        $rootScope.$emit('displayConditionIsInListModalError');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        if($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else{

                        //Updates the parent to register its children
                        var parentData = helpers.getConnectionById($scope.connections.parent);
                        if(parentData){
                            parentData.children = [];
                            parentData.children.push($scope.connections.id);
                            helpers.updateConnections(parentData);
                        }
                        //Save to the global canvas object
                        helpers.updateConnections($scope.connections);

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index > -1) {
                            $rootScope.unsavedData.splice(index, 1);
                        }

                        //Displays th form data
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIsInListModal');
                        //Displays action menu
                        $scope.displaySubMenu = false;
                        //Hides Error
                        $scope.displayError = false;

                        const desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');
                        if(desc) {
                            $scope.description = desc;
                        }

                        //Save Journey to template
                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);
                        if ($scope.isElegibleForUpdate) {
                            $scope.wasSave = true;
                            $timeout(() => {
                                $scope.wasSave = false;
                            }, 1500);
                        }
                        //Set Back to autoSave
                        $scope.isElegibleForUpdate = true;
                        //Remove Activate Error since its being able to save
                        $scope.displayActivateError = false;
                        $scope.displayErrorBlink = false;
                    }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };


                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    if ($scope.connections.data.selectedList.length === 0 || $scope.descriptionEmpty) {
                        $scope.displayError = true;

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }

                        return false
                    }

                    return true;
                };

                //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
                $scope.toggelListItem = function (listItem) {
                    var index = $scope.connections.data.selectedList.indexOf(listItem);
                    if (index > -1) {
                        $scope.connections.data.selectedList.splice(index, 1);
                    } else {
                        $scope.connections.data.selectedList.push(listItem);
                    }

                    if ($scope.connections.data.selectedList.length) {
                        $scope.selectedKey = $scope.translate('commons.editSelection');
                    } else {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                    }
                };

                //Cancel Button
                $scope.cancel = function() {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if(conn) {
                            $scope.connections.data = conn.data;
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if(newTop !== $scope.connections.top || $scope.connections.left !== newLeft){
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if(!wasUpdated){
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }

                        $rootScope.$emit('hideConditionIsInListModal');

                        return false;
                    }
                    //Show form menu
                    if($scope.displayList === false){
                        $scope.displayList = true;
                        $rootScope.$emit('displayConditionIsInListModal', $scope.connections);
                    }else{
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIsInListModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = () => {
                    // displays tip modal
                    $rootScope.$emit('displayConditionIsInListModal', $scope.connections, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    }
                    else {
                        if($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none'){
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideConditionIsInListModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionIsInListModal', $scope.connections);
                            } else if ($scope.connections.data.selectedList.length === 0) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionIsInListModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideConditionIsInListModal');
                            }
                            else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideConditionIsInListModal');
                            }
                        }
                    }
                };

                $scope.getSelectedText = (desc) => {
                    if ($scope.connections.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.parseDescription = function(desc, selected) {
                    if (desc && typeof desc === 'object'){
                        var descriptionCheck = false;
                        for (var item in desc){
                            if(desc[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                //Lists that are currently selected on the node
                                var totalLists = $scope.connections.data.selectedList.length;
                                desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                                //One list selected and > 19
                                if ( totalLists === 1 && desc.length > 15) {
                                    desc = desc.slice(0, 15) + '...';
                                //More than one selected
                                } else if (totalLists > 1) {
                                     desc = totalLists + $scope.translate('commons.selectedList');
                                }
                                break;
                            }
                        }
                        if(!descriptionCheck) {
                            $scope.descriptionEmpty = true;

                            if (selected === 'showSelectedList') {
                                return '';
                            } else {
                                return $scope.translate('commons.enterDetails');
                            }
                        }

                    } else {
                        $scope.descriptionEmpty = true;

                        if (selected === 'showSelectedList') {
                            return '';
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.parseDescriptionMenu = function(desc) {
                    if (desc && typeof desc === 'object'){
                        for (var item in desc){
                            desc = helpers.getContactListItem(item, $scope.contactListData);
                            desc = desc.slice(0, 19) + '...';
                            break;
                        }

                    }else {
                        return '...';
                    }

                    return desc;
                };


                $scope.displayModal = function() {
                    $scope.contactListData = $rootScope.contactListData;
                    $scope.modalWindow = true;
                    $rootScope.$emit('displayExtraVeil', true);
                };

                $scope.hideModal = function(clearList) {
                    if(clearList) {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                        $scope.connections.data.selectedList = [];
                    }
                    $scope.modalWindow = false;
                    $rootScope.$emit('displayExtraVeil', false);
                };

                $scope.setLastElem = function(evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function() {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideConditionIsListModal', function() {
                    if($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        }else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    }else {
                        $scope.contMenu = 0;
                    }
                });

                $scope.description = '';
                $rootScope.$watch('segmentData', (list) => {
                    if(list && list.length && $scope.connections) {
                        $scope.segmentData = list;
                        const desc = $scope.parseDescription($scope.connections.data.selectedList, 'showDescription');

                        if(desc) {
                            $scope.description = desc;
                            $scope.placeholder = false;
                        }
                    }
                });

                $scope.$watch('connections', (conn) => {
                    if(conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if(conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function (scope, elem, attr) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;
                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections){
                        if(document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = false;
                    scope.placeholder = true;

                    scope.selectedKey = scope.translate('commons.selectList');
                    if(scope.connections.data.selectedList.length) {
                        scope.selectedKey = scope.translate('commons.editSelection');
                    }

                    var template = $templateCache.get('conditions/is-on-list-or-segment');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveConditionIsInListData' + scope.connections.id, function(evt, conn, descriptionEmpty) {
                        scope.contactListData = $rootScope.contactListData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    scope.contactListData = $rootScope.contactListData;

                    if(scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(() => {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000)
                    } else if(scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save();
                }

                $(elem).click(function (evt) {
                    //Load Template
                    var template = $templateCache.get('conditions/is-on-list-or-segment'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    $rootScope.activePlus = false;

                    scope.selectedKey = scope.translate('commons.selectList');

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: (lastElement.type == 'RectangleConnection') ? (lastElement.top - 43) : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Condition',
                        data: {selectedList: []},
                        elemClass: attr.$attr,
                        elemName: 'IsOnList',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function() {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;

                        if(scope.displayError) {
                            $timeout(function() {
                                scope.displayList = true;
                                $rootScope.$emit('displayConditionIsInListModal', scope.connections);
                            }, 250)
                        }
                    });

                    $rootScope.$on('saveConditionIsInListData' + scope.connections.id, function(evt, conn, descriptionEmpty) {
                        scope.contactListData = $rootScope.contactListData;
                        scope.descriptionEmpty = descriptionEmpty;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the is in the list node
                    $rootScope.$on('deleteIsInListNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    $rootScope.$emit('displayConditionIsInListModal', scope.connections);

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    scope.displayList = true;

                    plumbService.connectElements(lastElement, scope.connections);

                    scope.contactListData = $rootScope.contactListData;
                });

                scope.deleteElement = function() {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                        $rootScope.activePlus = true;
                    }else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function() {
                    if(scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
}());




// WEBPACK FOOTER //
// ./app/directives/canvas_directives/is-on-list-or-segment.js